import type { RevokeCheckboxField } from '../types.ts';

export const REVOKE_CHECKBOX_FIELDS: RevokeCheckboxField[] = [
  'disagreeWithProcessingPurpose',
  'disagreeWithPersonalDataScope',
  'otherReason',
];
